import {
  FlightSelectors,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import "./styles.scss";
import { getFlightTotalInPrices } from "../../../modules/flight-checkout/selectors";
import { SharedFlightCtaSection } from "../../SharedFlightCtaSection";

export interface ICheckoutCtaSectionProps {
  onClick: () => void;
  buttonDisabled?: boolean;
  showCombinedTotal?: boolean;
}

const FlightCheckoutCtaSection = ({
  onClick,
  buttonDisabled = false,
  showCombinedTotal = false,
}: ICheckoutCtaSectionProps) => {
  const { formatFiatCurrency } = useI18nContext();
  const fareDetails = useSelector(FlightSelectors.getSelectedFareDetails);
  const tripCategory = useSelector(FlightSelectors.getTripCategoryParent);
  const flightTotalInPrices = useSelector(getFlightTotalInPrices);

  const totalPrice = showCombinedTotal
    ? flightTotalInPrices.fiat
    : fareDetails?.paxPricings?.[0]?.pricing?.total?.fiat || {
        value: 0,
        currencyCode: "BRL",
        currencySymbol: "R$",
      };

  const discountedPrice =
    fareDetails?.paxPricings?.[0]?.pricing?.totalWithDiscount?.fiat;

  // Per-traveler steps (contact, passengers): preserve pre-PR 2dp string. Review uses showCombinedTotal instead.
  const totalPriceString =
    !showCombinedTotal && totalPrice
      ? formatFiatCurrency(totalPrice)
      : undefined;

  return (
    <SharedFlightCtaSection
      discountedPrice={discountedPrice}
      totalPrice={totalPrice}
      totalPriceString={totalPriceString}
      tripCategory={tripCategory}
      onClick={onClick}
      buttonDisabled={buttonDisabled}
      showCombinedTotal={showCombinedTotal}
    />
  );
};

export default FlightCheckoutCtaSection;
